<section class="article-list mt-4">
  @if (vm$ | async; as vm) {
    @if (vm.isLoading) {
      <p class="text-sm text-text-muted">Loading numeron...</p>
    } @else if (vm.hasError || vm.numeronCollection === null) {
      <p class="text-sm text-text-muted">Numeron is unavailable right now. Please try again.</p>
    } @else {
      @if (vm.numeronCollection.isCollection) {
        <h2 class="mb-3 text-xl font-semibold text-text">{{ vm.numeronCollection.title }}</h2>
      }

      <div class="container">
        <div class="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          @for (numeron of vm.numeronCollection.numerons; track numeron._id) {
            <app-numeron-card
              [numeron]="numeron"
              [numeronCollection]="vm.numeronCollection"
            ></app-numeron-card>
          }
        </div>
      </div>
    }
  }
</section>
